<section style="background-color: whitesmoke; overflow: auto; height: calc(100vh - 54px);">
    <h2>Upload Contents</h2>
    <app-vcl-filter [pageId]="pageId" [modes]="modes" [userInfos]="userInfos" (filterDataOutputEvent)="filterUploadContent($event)"
    style="padding: 8px;"></app-vcl-filter>
    <app-upload-content #appUploadContent [platformInfos]="platformInfos"></app-upload-content>
</section>